import styled from 'styled-components'

import ProductCard from '../ProductCard'

export const BestProductsWrapper = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fill, 305px);
  grid-gap: 3rem;
`

export const BestProductsItem = styled(ProductCard)``

export const NoItemText = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBaseMedium};
  text-align: center;
`
